import { TranslateService } from '@shared/translate/translate.service';
import { ColGroupDef } from '@ag-grid-community/core';
import { PpssYieldsComponent } from '../../ppss/ppss-yields/ppss-yields.component';
import { AgGridHelperService } from '../../services/ag-grid-helper.service';

/**
 * Return yield column definitions for US MMF.
 * @param ppssTab ppss tab component
 * @param agGridHelperService ag grid helper service instance
 * @param translateService translate service instance
 */
export function getYieldColumnDefsForUS_MMF(
  ppssTab: PpssYieldsComponent,
  agGridHelperService: AgGridHelperService,
  translateService: TranslateService
): ColGroupDef[] {
  const colGroupDefs: ColGroupDef[] = [
    {
      groupId: 'FUND',
      headerGroupComponent: 'calcTypeGroupHeaderComponent',
      headerGroupComponentParams: {
        parentComponent: ppssTab,
        configurationName: ppssTab.productType,
        calcType: ppssTab.calcType,
      },
      children: [
        agGridHelperService.getFavFundColDef(ppssTab),
        agGridHelperService.getFundNameColDef(false),
        agGridHelperService.getShareClassNameColDef(),
      ],
    },
    {
      groupId: 'YIELD',
      headerName: `${translateService.instant(
        'products.30day-std-yield-date'
      )} ${ppssTab.navAsOfDate}`,
      children: [
        agGridHelperService.get7DayCurrentYieldWithWaiverColDef(),
        agGridHelperService.get7DayCurrentYieldWithoutWaiverColDef(),
        agGridHelperService.get7DayEffectiveYieldWithWaiverColDef(),
        agGridHelperService.get7DayEffectiveYieldWithoutWaiverColDef(),
      ],
    },
    {
      groupId: 'CHARGES',
      children: [agGridHelperService.getExpenseRatioColDef()],
    },
  ];
  ppssTab.calcTypeParams = colGroupDefs.find(
    (colGroupDef: ColGroupDef): boolean => colGroupDef.groupId === 'FUND'
  ).headerGroupComponentParams;
  return colGroupDefs;
}
